<!--赖传峰-->
<!--2022/1/24-->
<template>
  <div class="premium-rights">
    <div class="desc-block">
      <div
        v-for="item in metaData"
        :key="item.title"
        class="desc-item"
      >
        <div class="desc-icon">
          <component
            :is="item.icon"
            :color="svgColor"
          />
        </div>
        <div class="desc-text">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '#imports'
import { computed } from 'vue'
import HDQualitySVG from './HDQualitySVG.vue'
import InfinityUploadSVG from './InfinityUploadSVG.vue'
import NoAdSVG from './NoAdSVG.vue'
import StorageSVG from './StorageSVG.vue'

const { t } = useI18n()

const props = withDefaults(defineProps<{ premium?: boolean }>(), { premium: false })

const svgColor = computed(() => (props.premium ? 'var(--color-premium)' : 'var(--color-primary)'))

const metaData = computed(() => [
  {
    icon: StorageSVG,
    title: t('premium-rights-storage'),
  },
  {
    icon: InfinityUploadSVG,
    title: t('premium-rights-upload'),
  },
  {
    icon: HDQualitySVG,
    title: t('premium-rights-hd-video'),
  },
  {
    icon: NoAdSVG,
    title: t('premium-rights-no-ads'),
  },
])
</script>

<style lang="less" scoped>
@import '@/assets/styles/util.less';

.premium-rights {
  border-radius: 16px;
}

.desc {
  font-weight: 600;
  font-size: 24px;
  line-height: 42px;

  &-block {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  &-item {
    flex: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
  }

  &-text {
    margin-top: 16px;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
  }

  &-item .desc-icon {
    width: 72px;
    height: 72px;
    border-radius: 50%;
  }
}

@media screen and (max-width: @mobile-break-width) {
  .desc-item {
    flex: 50%;
  }
}
</style>
